import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./useAuth";

export default function RequireAuth() {
  const { isAuthenticated, initialized } = useAuth();

  // ⚠️ No desmontar todo si ya estuvo autenticado antes
  if (!initialized) {
    return null; // 👈 NO renderizar pantalla intermedia
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
